/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portions_LabelInputs */

const en_portions_label = /** @type {(inputs: Portions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portions`)
};

const de_portions_label = /** @type {(inputs: Portions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portionen`)
};

/**
* | output |
* | --- |
* | "Portions" |
*
* @param {Portions_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const portions_label = /** @type {((inputs?: Portions_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portions_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portions_label(inputs)
	return en_portions_label(inputs)
});